module.exports = __webpack_public_path__ + "img/TOP1.a6ba27a4.png";